// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 9999;
  animation: fadeInOverlay 0.2s ease-out;
}

@keyframes fadeInOverlay {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.profile-modal__panel {
  background: linear-gradient(135deg, #171127 0%, #20173A 100%);
  border-radius: 16px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);
  width: min(450px, calc(100vw - 32px));
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  animation: modalIn 0.22s ease-out;
}

@keyframes modalIn {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes modalSheetIn {
  from {
    opacity: 0;
    transform: translateY(28px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (min-width: 640px) {
  .profile-modal__panel {
    max-height: calc(100dvh - 32px);
  }
}

.profile-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  position: sticky;
  top: 0;
  background: linear-gradient(135deg, #171127 0%, #20173A 100%);
  z-index: 10;
}

.profile-modal__header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #F4EEFF;
}

.profile-modal__close {
  background: none;
  border: none;
  color: #B8A7D4;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s;
}

.profile-modal__close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #F4EEFF;
}

.profile-modal__content {
  flex: 1 1;
  padding: 24px;
  overflow-y: auto;
}

.profile-section {
  margin-bottom: 24px;
}

.profile-section__title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #00E8C6;
  margin-bottom: 12px;
}

.profile-balance {
  background: rgba(0, 232, 198, 0.1);
  border: 1px solid rgba(0, 232, 198, 0.3);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.profile-balance__amount {
  font-size: 28px;
  font-weight: 700;
  color: #00E8C6;
}

.profile-balance__currency {
  font-size: 14px;
  font-weight: 600;
  color: #B8A7D4;
}

.profile-field {
  margin-bottom: 16px;
}

.profile-field__label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #B8A7D4;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.profile-field__display {
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #F4EEFF;
  font-size: 14px;
}

.profile-field__input {
  width: 100%;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: #F4EEFF;
  font-size: 14px;
  font-family: inherit;
  transition: all 0.2s;
}

.profile-field__input:focus {
  outline: none;
  border-color: #00E8C6;
  box-shadow: 0 0 0 2px rgba(0, 232, 198, 0.2);
  background: rgba(255, 255, 255, 0.08);
}

.profile-field__input::placeholder {
  color: #8774A8;
}

.profile-referral-code {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: rgba(255, 179, 71, 0.1);
  border: 1px solid rgba(255, 179, 71, 0.3);
  border-radius: 8px;
}

.profile-referral-code__text {
  flex: 1 1;
  color: #FFB347;
  font-family: monospace;
  font-size: 13px;
  font-weight: 600;
  word-break: break-all;
}

.profile-referral-code__copy {
  background: none;
  border: none;
  color: #FFB347;
  font-size: 18px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.2s;
  flex-shrink: 0;
}

.profile-referral-code__copy:hover {
  background: rgba(255, 179, 71, 0.2);
}

.profile-referred-users {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.profile-referred-users__item {
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
}

.profile-referred-users__name {
  color: #F4EEFF;
  font-size: 14px;
  font-weight: 600;
}

.profile-referred-users__meta {
  color: #B8A7D4;
  font-size: 12px;
  margin-top: 2px;
}

.profile-modal__message {
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 16px;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.profile-modal__message--success {
  background: rgba(76, 212, 161, 0.2);
  border: 1px solid rgba(76, 212, 161, 0.3);
  color: #4CD4A1;
}

.profile-modal__message--error {
  background: rgba(255, 93, 125, 0.2);
  border: 1px solid rgba(255, 93, 125, 0.3);
  color: #FF5D7D;
}

.profile-modal__footer {
  display: flex;
  gap: 12px;
  padding: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.2);
  position: sticky;
  bottom: 0;
}

.profile-modal__btn {
  flex: 1 1;
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.profile-modal__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.profile-modal__btn--primary {
  background: linear-gradient(135deg, #00E8C6 0%, #00B39A 100%);
  color: #09060F;
}

.profile-modal__btn--primary:not(:disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 232, 198, 0.3);
}

.profile-modal__btn--secondary {
  background: transparent;
  color: #B8A7D4;
  border: 1px solid rgba(255, 255, 255, 0.15);
}

.profile-modal__btn--secondary:not(:disabled):hover {
  background: rgba(255, 255, 255, 0.05);
  color: #F4EEFF;
}

/* Scrollbar styling */
.profile-modal__panel::-webkit-scrollbar {
  width: 6px;
}

@media (max-width: 639px) {
  .profile-modal-overlay {
    padding: 12px;
  }

  .profile-modal__panel {
    width: calc(100vw - 24px);
    max-height: calc(100dvh - 24px);
    border-radius: 14px;
  }
}

.profile-modal__panel::-webkit-scrollbar-track {
  background: transparent;
}

.profile-modal__panel::-webkit-scrollbar-thumb {
  background: rgba(0, 232, 198, 0.3);
  border-radius: 3px;
}

.profile-modal__panel::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 232, 198, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/styles/ProfileModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,iDAAiD;EACjD,gBAAgB;EAChB,MAAM;EACN,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,8CAA8C;EAC9C,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;EACrB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".profile-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  z-index: 9999;\n  animation: fadeInOverlay 0.2s ease-out;\n}\n\n@keyframes fadeInOverlay {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.profile-modal__panel {\n  background: linear-gradient(135deg, #171127 0%, #20173A 100%);\n  border-radius: 16px;\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);\n  width: min(450px, calc(100vw - 32px));\n  max-height: calc(100dvh - 32px);\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  animation: modalIn 0.22s ease-out;\n}\n\n@keyframes modalIn {\n  from {\n    opacity: 0;\n    transform: translateY(16px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes modalSheetIn {\n  from {\n    opacity: 0;\n    transform: translateY(28px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (min-width: 640px) {\n  .profile-modal__panel {\n    max-height: calc(100dvh - 32px);\n  }\n}\n\n.profile-modal__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  position: sticky;\n  top: 0;\n  background: linear-gradient(135deg, #171127 0%, #20173A 100%);\n  z-index: 10;\n}\n\n.profile-modal__header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #F4EEFF;\n}\n\n.profile-modal__close {\n  background: none;\n  border: none;\n  color: #B8A7D4;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  transition: all 0.2s;\n}\n\n.profile-modal__close:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #F4EEFF;\n}\n\n.profile-modal__content {\n  flex: 1;\n  padding: 24px;\n  overflow-y: auto;\n}\n\n.profile-section {\n  margin-bottom: 24px;\n}\n\n.profile-section__title {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: #00E8C6;\n  margin-bottom: 12px;\n}\n\n.profile-balance {\n  background: rgba(0, 232, 198, 0.1);\n  border: 1px solid rgba(0, 232, 198, 0.3);\n  border-radius: 12px;\n  padding: 16px;\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.profile-balance__amount {\n  font-size: 28px;\n  font-weight: 700;\n  color: #00E8C6;\n}\n\n.profile-balance__currency {\n  font-size: 14px;\n  font-weight: 600;\n  color: #B8A7D4;\n}\n\n.profile-field {\n  margin-bottom: 16px;\n}\n\n.profile-field__label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #B8A7D4;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 6px;\n}\n\n.profile-field__display {\n  padding: 10px 12px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: #F4EEFF;\n  font-size: 14px;\n}\n\n.profile-field__input {\n  width: 100%;\n  padding: 10px 12px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  color: #F4EEFF;\n  font-size: 14px;\n  font-family: inherit;\n  transition: all 0.2s;\n}\n\n.profile-field__input:focus {\n  outline: none;\n  border-color: #00E8C6;\n  box-shadow: 0 0 0 2px rgba(0, 232, 198, 0.2);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.profile-field__input::placeholder {\n  color: #8774A8;\n}\n\n.profile-referral-code {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  background: rgba(255, 179, 71, 0.1);\n  border: 1px solid rgba(255, 179, 71, 0.3);\n  border-radius: 8px;\n}\n\n.profile-referral-code__text {\n  flex: 1;\n  color: #FFB347;\n  font-family: monospace;\n  font-size: 13px;\n  font-weight: 600;\n  word-break: break-all;\n}\n\n.profile-referral-code__copy {\n  background: none;\n  border: none;\n  color: #FFB347;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 6px;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.profile-referral-code__copy:hover {\n  background: rgba(255, 179, 71, 0.2);\n}\n\n.profile-referred-users {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.profile-referred-users__item {\n  padding: 10px 12px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n}\n\n.profile-referred-users__name {\n  color: #F4EEFF;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.profile-referred-users__meta {\n  color: #B8A7D4;\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.profile-modal__message {\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 16px;\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.profile-modal__message--success {\n  background: rgba(76, 212, 161, 0.2);\n  border: 1px solid rgba(76, 212, 161, 0.3);\n  color: #4CD4A1;\n}\n\n.profile-modal__message--error {\n  background: rgba(255, 93, 125, 0.2);\n  border: 1px solid rgba(255, 93, 125, 0.3);\n  color: #FF5D7D;\n}\n\n.profile-modal__footer {\n  display: flex;\n  gap: 12px;\n  padding: 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(0, 0, 0, 0.2);\n  position: sticky;\n  bottom: 0;\n}\n\n.profile-modal__btn {\n  flex: 1;\n  padding: 12px 16px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.profile-modal__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.profile-modal__btn--primary {\n  background: linear-gradient(135deg, #00E8C6 0%, #00B39A 100%);\n  color: #09060F;\n}\n\n.profile-modal__btn--primary:not(:disabled):hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 16px rgba(0, 232, 198, 0.3);\n}\n\n.profile-modal__btn--secondary {\n  background: transparent;\n  color: #B8A7D4;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n}\n\n.profile-modal__btn--secondary:not(:disabled):hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: #F4EEFF;\n}\n\n/* Scrollbar styling */\n.profile-modal__panel::-webkit-scrollbar {\n  width: 6px;\n}\n\n@media (max-width: 639px) {\n  .profile-modal-overlay {\n    padding: 12px;\n  }\n\n  .profile-modal__panel {\n    width: calc(100vw - 24px);\n    max-height: calc(100dvh - 24px);\n    border-radius: 14px;\n  }\n}\n\n.profile-modal__panel::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.profile-modal__panel::-webkit-scrollbar-thumb {\n  background: rgba(0, 232, 198, 0.3);\n  border-radius: 3px;\n}\n\n.profile-modal__panel::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 232, 198, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
